<template>
  <el-dialog
    title="评论详细信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="商铺名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
              label="商品名称"
      >
        {{goodsname}}
      </el-form-item>
      <el-form-item
              label="商品图片"
      >

        <div v-if="image_url2!=null && image_url2!=''">
   <span v-for="(item,index) in this.image_url2.split(',')">
                 <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl(item)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 200px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl(item)" style="width: 200px;height: 200px; "/>
              </span>
              </span>

              </span>

        </div>

      </el-form-item>
      <el-form-item
        label="评论内容"
      >
        {{comment_content}}
      </el-form-item>

      <el-form-item
              label="评论图片"
      >

        <div v-if="image_url!=null && image_url!=''">
            <span v-for="item in this.image_url.split(',')">

                 <img :src= "getImgUrl(item)" style="width: 200px;height: 200px; "/><br/>

              </span>

        </div>

      </el-form-item>
      <el-form-item
              label="评论用户"
      >
        {{anonymous}}
      </el-form-item>
      <el-form-item
              label="服务态度"
      >
        {{service_attitude}}
      </el-form-item>
      <el-form-item
              label="商家评分"
      >
        {{merchant_ratings}}
      </el-form-item>
      <el-form-item
              label="商家总分"
      >
        {{merchant_total}}
      </el-form-item>
      <el-form-item
              label="浏览次数"
      >
        {{browse_times}}
      </el-form-item>
      <el-form-item
              label="点赞数"
      >
        {{praise_points}}
      </el-form-item>
      <el-form-item
              label="评论时间"
      >
        {{commentary_times}}
      </el-form-item>
      <el-form-item
              label="商家回复次数"
      >
        {{replies_number}}
      </el-form-item>
      <el-form-item
              label="审核状态"
      >
        {{sh_type}}
      </el-form-item>

      <el-form-item
              label="审核时间"
      >
        {{sh_times}}
      </el-form-item>

    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
        agentname:"",
        goodsname:"",
        image_url:"",
        image_url2:"",
        comment_content:"",
        anonymous:"",
        service_attitude:"",
        merchant_ratings:"",
        merchant_total:"",
        browse_times:"",
        praise_points:"",
        commentary_times:"",
        replies_number:"",
        sh_type:"",
        sh_times:"",
      form: {

      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        let form = {};
        this.form = form;
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {

          this.agentname=this.oneclass.shopname;
        this.goodsname=this.oneclass.goodsname;
              this.image_url=this.oneclass.image_url;
              this.image_url2=this.oneclass.goodsimg;
              this.comment_content=this.oneclass.comment_content;
              this.anonymous=this.oneclass.anonymous;
              this.service_attitude=this.oneclass.service_attitude;
              this.merchant_ratings=this.oneclass.merchant_ratings;
              this.merchant_total=this.oneclass.merchant_total;
              this.browse_times=this.oneclass.browse_times;
              this.praise_points=this.oneclass.praise_points;
              this.commentary_times=this.oneclass.commentary_times;
              this.replies_number=this.oneclass.replies_number;
              if(this.oneclass.sh_type=='0'){
                  this.sh_type="未审核";
              }else{
                  this.sh_type="已审核";
              }

              this.sh_times=this.oneclass.sh_times;





          this.formEdit = true;
      }
    },
      getImgUrl(item){
          return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+item;
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

